module.exports = __webpack_public_path__ + "img/price-down.598eb330.png";